import React from "react";
import { RadioOptionRow, RadioIconContainer, RadioIcon } from "./styled";
var customNodeRenderer = function (customNodeOptionRow) {
    var checked = customNodeOptionRow.checked, customNode = customNodeOptionRow.option.customNode;
    return (React.createElement(RadioOptionRow, null,
        React.createElement(RadioIconContainer, null,
            React.createElement(RadioIcon, { checked: checked })),
        customNode));
};
export default customNodeRenderer;
